export const singleAlertTypes = {
  FETCH_REQUEST: "ASSET_ALERT_SHIPMENT_FETCH_REQUEST",
  FETCH_SUCCESS: "ASSET_ALERT_SHIPMENT_FETCH_SUCCESS",
  UPDATE_FILTERS: "ASSET_ALERT_SHIPMENT_UPDATE_FILTERS",
  FETCH_FAILURE: "ASSET_ALERT_FETCH_FAILURE",
  ALERT_COUNT_SUCCESS: "ASSET_ALERT_ALERT_COUNT_SUCCESS",
  BULK_UPDATE_FILTER_FIELD: "ASSET_ALERT_BULK_SHIPMENT_UPDATE_FILTER_FIELD",
  BULK_UPDATE_FIELD: "ASSET_ALERT_BULK_SHIPMENT_UPDATE_FIELD",
  BULK_UPDATE_FILTER_BACK: "ASSET_ALERT_BULK_SHIPMENT_UPDATE_FILTER_BACK",
  BULK_UPDATE_FILTER: "ASSET_ALERT_BULK_SHIPMENT_UPDATE_FILTER",
  BULK_UPDATE_FILTER_SUCCESS: "ASSET_ALERT_BULK_SHIPMENT_UPDATE_FILTER_SUCCESS",
  BULK_UPDATE_FILTER_FAILURE: "ASSET_ALERT_BULK_SHIPMENT_UPDATE_FILTER_FAILURE",
  BULK_UPDATE_SUBMIT: "ASSET_ALERT_BULK_SHIPMENT_UPDATE_SUBMIT",
  BULK_UPDATE_RESPONSE: "ASSET_ALERT_BULK_SHIPMENT_UPDATE_RESPONSE",
  SINGLE_UPDATE_REQUEST: "ASSET_ALERT_SINGLE_UPDATE_REQUEST",
  SINGLE_UPDATE_SUBMIT: "ASSET_ALERT_SINGLE_UPDATE_SUBMIT",
  SINGLE_UPDATE_FIELD: "ASSET_ALERT_SINGLE_UPDATE_FIELD",
  SINGLE_UPDATE_RESPONSE: "ASSET_ALERT_SINGLE_UPDATE_RESPONSE",
  DOWNLOAD_REQUEST: "ASSET_ALERT_SHIPMENT_DOWNLOAD_REQUEST",
  DOWNLOAD_SUCCESS: "ASSET_ALERT_SHIPMENT_DOWNLOAD_SUCCESS",
  DOWNLOAD_FAILURE: "ASSET_ALERT_SHIPMENT_DOWNLOAD_FAILURE",
  RESET_BULK_UPDATE_FORM: "ASSET_ALERT_RESET_BULK_SHIPMENT_UPDATE_FORM",
  MAPDATA_TAB_INDEX: "ASSET_ALERT_MAPDATA_TAB_INDEX",
};

export const fetchalertRequest = (filter) => ({
  type: singleAlertTypes.FETCH_REQUEST,
  payload: filter,
});

export const fetchSuccess = (resp) => ({
  type: singleAlertTypes.FETCH_SUCCESS,
  payload: resp,
});

export const updateFilters = (resp) => ({
  type: singleAlertTypes.UPDATE_FILTERS,
  payload: resp,
});

export const mapDataTabIndex = (index) => ({
  type: singleAlertTypes.MAPDATA_TAB_INDEX,
  payload: index,
});

export const alertAlertCountSuccess = (resp) => ({
  type: singleAlertTypes.ALERT_COUNT_SUCCESS,
  payload: resp,
});

export const fetchFailure = (resp) => ({
  type: singleAlertTypes.FETCH_FAILURE,
  payload: resp,
});

export const bulkUpdateFilterField = (field) => ({
  type: singleAlertTypes.BULK_UPDATE_FILTER_FIELD,
  payload: field,
});

export const bulkUpdateField = (filter) => ({
  type: singleAlertTypes.BULK_UPDATE_FIELD,
  payload: filter,
});

export const bulkUpdateFilter = (filter) => ({
  type: singleAlertTypes.BULK_UPDATE_FILTER,
  payload: filter,
});

export const bulkUpdateFilterBack = () => ({
  type: singleAlertTypes.BULK_UPDATE_FILTER_BACK,
});

export const bulkUpdateFilterSuccess = (count) => ({
  type: singleAlertTypes.BULK_UPDATE_FILTER_SUCCESS,
  payload: count,
});

export const bulkUpdateFilterFailure = () => ({
  type: singleAlertTypes.BULK_UPDATE_FILTER_FAILURE,
});

export const bulkUpdateSubmit = (selectedItems) => ({
  type: singleAlertTypes.BULK_UPDATE_SUBMIT,
  payload:selectedItems
});

export const bulkUpdateResponse = (resp) => ({
  type: singleAlertTypes.BULK_UPDATE_RESPONSE,
  payload: resp,
});

export const singleUpdateRequest = (filter) => ({
  type: singleAlertTypes.SINGLE_UPDATE_REQUEST,
  payload: filter,
});

export const singleUpdateField = (filter) => ({
  type:singleAlertTypes.SINGLE_UPDATE_FIELD,
  payload: filter,
});

export const singleUpdateSubmit = () => ({
  type:singleAlertTypes.SINGLE_UPDATE_SUBMIT,
});

export const singleUpdateResponse = (resp) => ({
  type: singleAlertTypes.SINGLE_UPDATE_RESPONSE,
  payload: resp,
});

export const downloadRequest = (total) => ({
  type: singleAlertTypes.DOWNLOAD_REQUEST,
  payload: total,
});

export const downloadSuccess = (resp) => ({
  type: singleAlertTypes.DOWNLOAD_SUCCESS,
  payload: resp,
});

export const downloadFailure = (error) => ({
  type:singleAlertTypes.DOWNLOAD_FAILURE,
  payload: error,
});

export const resetBulkUpdateForm = () => ({
  type: singleAlertTypes.RESET_BULK_UPDATE_FORM,
});
